import { ILaya } from "../../../ILaya";
import { LayaGL } from "../../layagl/LayaGL";
import { Matrix3x3 } from "../../maths/Matrix3x3";
import { Point } from "../../maths/Point";
import { Vector2 } from "../../maths/Vector2";
import { Vector4 } from "../../maths/Vector4";
import { ShaderDataType } from "../../RenderDriver/DriverDesign/RenderDevice/ShaderData";
import { Shader3D } from "../../RenderEngine/RenderShader/Shader3D";
import { RenderState2D } from "../../webgl/utils/RenderState2D";
import { Area2D } from "../Area2D";
import { Scene } from "../Scene";
import { Sprite } from "../Sprite";
export class Camera2D extends Sprite {
    static shaderValueInit() {
        if (!Scene.scene2DUniformMap) {
            Scene.scene2DUniformMap = LayaGL.renderDeviceFactory.createGlobalUniformMap("Sprite2DGlobal");
        }
        let scene2DUniformMap = Scene.scene2DUniformMap;
        Camera2D.VIEW2D = Shader3D.propertyNameToID("u_view2D");
        scene2DUniformMap.addShaderUniform(Camera2D.VIEW2D, "u_view2D", ShaderDataType.Matrix3x3);
        Camera2D.SHADERDEFINE_CAMERA2D = Shader3D.getDefineByName("CAMERA2D");
    }
    get ignoreRotation() {
        return this._ignoreRotation;
    }
    set ignoreRotation(value) {
        this._ignoreRotation = value;
    }
    get isMain() {
        return this._isMain;
    }
    set isMain(value) {
        if (this._ownerArea) {
            if (value) {
                this._ownerArea._setMainCamera(this);
                this._isMain = true;
            }
            else {
                if (this._ownerArea.mainCamera == this) {
                    this._ownerArea._setMainCamera(null);
                    this._isMain = false;
                }
            }
        }
        this._isMain = value;
    }
    _setUnBelongScene() {
        if (this._ownerArea != null) {
            if (this._ownerArea.mainCamera == this)
                this._ownerArea._setMainCamera(null);
            this._ownerArea = null;
        }
        super._setUnBelongScene();
    }
    _setBelongScene(scene) {
        super._setBelongScene(scene);
        this._findOwnerArea();
    }
    _findOwnerArea() {
        let ele = this;
        while (ele) {
            if (ele === this._scene || ele === ILaya.stage)
                break;
            if (ele instanceof Area2D) {
                this._ownerArea = ele;
                if (this._isMain && !this._ownerArea.mainCamera)
                    this._ownerArea._setMainCamera(this);
                break;
            }
            ele = ele._parent;
        }
        if (this._ownerArea == null) {
            console.warn("Camera2D must be a descendant of Area2D");
        }
    }
    get zoom() {
        return this._zoom;
    }
    set zoom(value) {
        if (value) {
            value.cloneTo(this._zoom);
        }
    }
    get limit_Left() {
        return this._limit_Left;
    }
    set limit_Left(value) {
        this._limit_Left = value;
    }
    get limit_Right() {
        return this._limit_Right;
    }
    set limit_Right(value) {
        this._limit_Right = value;
    }
    get limit_Bottom() {
        return this._limit_Bottom;
    }
    set limit_Bottom(value) {
        this._limit_Bottom = value;
    }
    get limit_Top() {
        return this._limit_Top;
    }
    set limit_Top(value) {
        this._limit_Top = value;
    }
    get positionSmooth() {
        return this._positionSmooth;
    }
    set positionSmooth(value) {
        this._positionSmooth = value;
    }
    get positionSpeed() {
        return this._positionSpeed;
    }
    set positionSpeed(value) {
        this._positionSpeed = value;
    }
    get dragHorizontalEnable() {
        return this._dragHorizontalEnable;
    }
    set dragHorizontalEnable(value) {
        this._dragHorizontalEnable = value;
    }
    get dragVerticalEnable() {
        return this._dragVerticalEnable;
    }
    set dragVerticalEnable(value) {
        this._dragVerticalEnable = value;
    }
    get drag_Left() {
        return this._drag_Left;
    }
    set drag_Left(value) {
        this._drag_Left = value;
    }
    get drag_Right() {
        return this._drag_Right;
    }
    set drag_Right(value) {
        this._drag_Right = value;
    }
    get drag_Top() {
        return this._drag_Top;
    }
    set drag_Top(value) {
        this._drag_Top = value;
    }
    get drag_Bottom() {
        return this._drag_Bottom;
    }
    set drag_Bottom(value) {
        this._drag_Bottom = value;
    }
    getCameraPos() {
        return this._cameraPos;
    }
    constructor() {
        super();
        this._cameraPos = new Vector2();
        this._cameraSmoothPos = new Vector2();
        this._firstUpdate = true;
        this._cameraMatrix = new Matrix3x3();
        this._cameraInvertMatrix = new Matrix3x3();
        this._ignoreRotation = true;
        this._viewRect = new Vector2();
        this.limit_Left = -10000000;
        this.limit_Right = 10000000;
        this.limit_Top = -10000000;
        this.limit_Bottom = 10000000;
        this.drag_Left = 0.2;
        this.drag_Right = 0.2;
        this.drag_Top = 0.2;
        this.drag_Bottom = 0.2;
        this.positionSmooth = false;
        this._rect = new Vector4();
        this._zoom = new Vector2(1, 1);
    }
    _getScreenSize() {
        this._viewRect.setValue(RenderState2D.width, RenderState2D.height);
        return this._viewRect;
    }
    _getCameraTransform() {
        let viewport = this._getScreenSize();
        let curPosPoint = Point.TEMP;
        this.globalTrans.getScenePos(curPosPoint);
        let extendHorizental = viewport.x * 0.5;
        let extendVertical = viewport.y * 0.5;
        if (!this._firstUpdate) {
            if (this.dragHorizontalEnable) {
                this._cameraPos.x = Math.min(this._cameraPos.x, curPosPoint.x + extendHorizental * this.drag_Left);
                this._cameraPos.x = Math.max(this._cameraPos.x, curPosPoint.x - extendHorizental * this.drag_Right);
            }
            else {
                this._cameraPos.x = curPosPoint.x;
            }
            if (this.dragVerticalEnable) {
                this._cameraPos.y = Math.min(this._cameraPos.y, curPosPoint.y + extendVertical * this.drag_Top);
                this._cameraPos.y = Math.max(this._cameraPos.y, curPosPoint.y - extendVertical * this.drag_Bottom);
            }
            else {
                this._cameraPos.y = curPosPoint.y;
            }
            let sceneRect_left = this._cameraPos.x - extendHorizental;
            let sceneRect_right = sceneRect_left + viewport.x;
            let sceneRect_top = this._cameraPos.y - extendVertical;
            let sceneRect_bottom = sceneRect_top + viewport.y;
            if (sceneRect_left < this.limit_Left) {
                this._cameraPos.x -= sceneRect_left - this.limit_Left;
            }
            if (sceneRect_right > this.limit_Right) {
                this._cameraPos.x -= sceneRect_right - this.limit_Right;
            }
            if (sceneRect_bottom > this.limit_Bottom) {
                this._cameraPos.y -= sceneRect_bottom - this.limit_Bottom;
            }
            if (sceneRect_top < this.limit_Top) {
                this._cameraPos.y -= sceneRect_top - this.limit_Top;
            }
            if (this.positionSmooth) {
                let speed = Math.min(1.0, this.positionSpeed * 0.16);
                let transX = Math.floor((this._cameraPos.x - this._cameraSmoothPos.x) * speed);
                let transY = Math.floor((this._cameraPos.y - this._cameraSmoothPos.y) * speed);
                this._cameraSmoothPos.x += transX;
                this._cameraSmoothPos.y += transY;
            }
            else {
                this._cameraSmoothPos.x = this._cameraPos.x;
                this._cameraSmoothPos.y = this._cameraPos.y;
            }
        }
        else {
            this._cameraSmoothPos.x = this._cameraPos.x = curPosPoint.x;
            this._cameraSmoothPos.y = this._cameraPos.y = curPosPoint.y;
            this._firstUpdate = false;
        }
        if (!this.ignoreRotation) {
            if (this.rotationSmooth) {
            }
            else {
                this._cameraRotation = this.globalTrans.rotation;
            }
        }
        else {
            this._cameraRotation = 0;
        }
        this._rect.setValue(this._cameraSmoothPos.x - extendHorizental, this._cameraSmoothPos.x + extendHorizental, this._cameraSmoothPos.y - extendVertical, this._cameraSmoothPos.y + extendVertical);
        Matrix3x3.createMatrixFromValue(this._cameraSmoothPos, this._cameraRotation * Math.PI / 180, this._zoom, this._cameraMatrix);
        this._cameraMatrix.invert(this._cameraInvertMatrix);
        return this._cameraInvertMatrix;
    }
}
